import React from "react";
import { withRouter } from "react-router-dom";
import { getUserAvatarUrl } from "../firebase/storage";
import TitleBar from "../components/TitleBar";
import RaisedButton from "../components/RaisedButton";
import InnerBody from "../components/InnerBody";
import Header from "../components/Header";
import NavigationSideBar from "../components/NavigationSideBar";
import withAuthorization from "../firebase/withAuthorization";
import {
  getProject,
  deleteDocument,
  getProjectUpdates,
  getSingleClientUpdates
} from "../firebase/firestore";
import AuthUserContext from "../firebase/AuthUserContext";
import withProfile from "../utils/withProfile";
import { firestore } from "../firebase/firebase";
import { dateToStringShort } from "../utils/DateHelper";
import withAccount from "../utils/withAccount";
import TextInput from "../components/TextInput";
import { LandingHeader } from "./PageLanding";

class PageProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      profilePicture: null
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    this.setState({ isLoading: false });

    getUserAvatarUrl(
      this.props.profile.id,
      url => {
        this.setState({ profilePicture: url });
      },
      error => {
        this.setState({ profilePicture: null });
      }
    );
  }

  saveProfileData() {
    const ref = firestore
      .collection("users")
      .doc("v1Y9JqtULuMFNxisX7S86qm5di02");
    ref.update({
      born: "12.02.2030",
      country: "DE",
      first: "Ralf",
      gender: "male",
      last: "Moritz",
      phone: "0429 249 429"
    });
  }

  render() {
    const { profilePicture } = this.state;
    const { profile, account, history } = this.props;

    return (
      <div>
        <LandingHeader profile={profile} history={history} />
        <InnerBody isLoading={this.state.isLoading} noSidebar>
          <AuthUserContext.Consumer>
            {authUser => (
              <div>
                <TitleBar title="Profildaten">
                  <RaisedButton
                    label="Bearbeiten"
                    onClick={() => {
                      alert("Nope.");
                    }}
                  />
                </TitleBar>
                <h4>Profilbild</h4>
                <img
                  height="128px"
                  width="128px"
                  alt="Profile"
                  src={profilePicture}
                />

                <h4>Person</h4>
                <TextInput placeholder="Vorname" value={profile.first} />
                <TextInput placeholder="Nachname" value={profile.last} />
                <TextInput placeholder="Geschlecht" value={profile.gender} />
                <TextInput
                  placeholder="Geburtsdatum"
                  value={dateToStringShort(profile.born.toDate())}
                />

                <h4>Kontakt</h4>
                <TextInput placeholder="E-Mail" value={authUser.email} />
                <TextInput placeholder="Telefon" value={profile.phone} />
                <TextInput placeholder="Land" value={profile.country} />

                <h4>Info</h4>
                <TextInput
                  placeholder="Beitritt"
                  value={dateToStringShort(profile.accession.toDate())}
                />
                <br />
                <small style={{ color: "var(--color-bad)" }}>
                  * Pflichtfeld
                </small>
                <br />
                <h4>Weiteres</h4>
                <p className="Link">Email ändern</p>
                <p className="Link">Passwort ändern</p>
                <p
                  className="Link"
                  style={{ color: "var(--color-bad)" }}
                >{`Mitgliedschaft bei ${account.name} auflösen`}</p>
              </div>
            )}
          </AuthUserContext.Consumer>
        </InnerBody>
      </div>
    );
  }
}

const authCondition = authUser => !!authUser;
export default withAuthorization(authCondition)(
  withRouter(withProfile(withAccount(PageProfile)))
);



// WEBPACK FOOTER //
// ./src/pages/PageProfile.js